'use client';

import { Button, Carousel } from '.';
import { renderProductCards } from 'features/homepage';
import { ProductDocument } from 'models/product';

type NewArrivalsProps = {
  products: ProductDocument[];
  isFetching: boolean;
  basis?: string;
  smallProducts?: boolean;
};

export default function NewArrivals({
  products,
  isFetching,
  basis,
  smallProducts,
}: NewArrivalsProps) {
  return (
    <div className={`flex w-full flex-col gap-[1.6rem] p-4 ${basis}`}>
      {products?.length > 0 && (
        <Carousel
          key="favoriteProducts"
          items={renderProductCards(products, {
            data_source: 'firebase',
            section: 'new-arrivals',
            size: smallProducts ? 'sm' : 'md',
          })}
          basis={basis}
          loading={isFetching}
        />
      )}
    </div>
  );
}
